import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {
  AddForm2Favorite_Request,
  BaseResponse,
  DABDashboard_Request,
  DABDashboard_Response,
  DABGetAllDynamicReportGroup_Request,
  DABGetAllDynamicReportGroup_Response,
  DABGetDynamicReportGroup_Request,
  DABGetDynamicReportGroup_Response,
  DABReport_Request,
  DABReport_Response,
  DABReportGroup_Request,
  DABReportGroup_Response,
  DListAction_Request,
  DlistDto,
  FormAction_Request,
  FormActionDto,

  GetDlist_Request,
  GetDlist_Response,
  GetFormMetadata_Request,
  GetFormMetadata_Response,
  GetKullaniciAd_Request,
  GetKullaniciAd_Response,
  GetKullaniciBilgi_Request,
  GetKullaniciBilgi_Response,
  GetLookup_Request,
  GetLookup_Response,
  GetMenuTree_Request,
  GetMenuTree_Response,
  GetPersonelBilgi_Request,
  GetPersonelBilgi_Response,
  IkaGUI_PersonelIzin_Request,
  ReportAction_Request, ReportAction_Response, SetDlist_Request
} from '../models/ortak.dtos';
import {BehaviorSubject, catchError, map, Observable, shareReplay, take} from 'rxjs';
import {ColumnModel, LookupModel} from '../models/dx-data-table.model';
import {environment} from "./app-settings.service";
import {ButtonWithIconObject, DynamicButton} from "../constants";
import {DataCoreService} from "./data-core.service";
import {UtilsService} from "./utils.service";
import {GetParametreDeger_Response} from "../models/created.model";
import { GAS_Get_ArsivKod_Request, GAS_Get_ArsivKod_Response } from 'libs/gas/src/lib/models/dtos';
import {ApiResult, JsonApiClient} from "@servicestack/client";
import {GetLastXAction_Request} from "@dabnet-kamu/libs/gen/models/manuel-models";
import {AuthService} from "@dabnet-kamu/libs/auth";


@Injectable({
  providedIn: 'root'
})


export class OrtakService {
  client = JsonApiClient.create(environment.ortakService);
  clientGen = JsonApiClient.create(environment.genService);

  private _lookUpData: BehaviorSubject<GetLookup_Response | null> = new BehaviorSubject(null);
  public lookUpData$ = this._lookUpData.asObservable();
  public lookUpData: LookupModel[] = [];

  public type?: number;
  public allowAdd?: boolean;
  public allowEdit?: boolean;
  public allowDelete?: boolean;
  public mode?: string;
  ortServiceUrl = `${environment.ortakService}api`;

  private kullaniciBilgi$: Observable<GetKullaniciBilgi_Response> | null = null;

  constructor(private utilsService: UtilsService,
              private httpClient: HttpClient,
              public dataCoreService: DataCoreService,
  ) {
  }


  addForm2Favorite(formId: number,
                   removeYn: boolean): Observable<BaseResponse> {
    const request = new AddForm2Favorite_Request({
      formId: formId,
      removeYn: removeYn
    });

    return this.httpClient.post<BaseResponse>(`${this.ortServiceUrl}/AddForm2Favorite_Request`, request).pipe(
      map((res) => {
        return res as BaseResponse
      })
    );
  }


  getReportForm(reportCode: string,selectedYear?:number): Observable<DABReport_Response> {
    const request = new DABReport_Request({
      reportCode: reportCode,
      selectedYear:selectedYear
    });

    return this.httpClient.post<DABReport_Response>(`${this.ortServiceUrl}/DABReport_Request`, request).pipe(
      map((res) => {
        return res as DABReport_Response;
      })
    );
  }


  getReportGroupForm(reportGroupCode: string): Observable<DABReportGroup_Response> {
    const request = new DABReportGroup_Request({
      reportGroupCode: reportGroupCode
    });

    return this.httpClient.post<DABReportGroup_Response>(`${this.ortServiceUrl}/DABReportGroup_Request`, request).pipe(
      map((res) => {
        return res as DABReportGroup_Response;
      })
    );
  }

  getDynamicReportGroupForm(dynamicReportGroupCode?:string): Observable<DABGetDynamicReportGroup_Response> {
    const request = new DABGetDynamicReportGroup_Request({
       dynamicReportGroupCode: dynamicReportGroupCode
    });

    return this.httpClient.post<DABGetDynamicReportGroup_Response>(`${this.ortServiceUrl}/DABGetDynamicReportGroup_Request`, request).pipe(
      map((res) => {
        return res as DABGetDynamicReportGroup_Response;
      })
    );
  }



  getAllDynamicReportGroupForm(): Observable<DABGetAllDynamicReportGroup_Response> {
    const request = new DABGetAllDynamicReportGroup_Request({});

    return this.httpClient.post<DABGetAllDynamicReportGroup_Response>(`${this.ortServiceUrl}/DABGetAllDynamicReportGroup_Request`, request).pipe(
      map((res) => {
        return res as DABGetAllDynamicReportGroup_Response;
      })
    );
  }




  getDList(dListCode: string): Observable<GetDlist_Response> {
    const params = new HttpParams().
    set('dListCode', dListCode);

    return this.httpClient.get<GetDlist_Response>(`${this.ortServiceUrl}/GetDlist_Request`, { params }).pipe(
      map((res) => res as GetDlist_Response)
    );
  }

  getDlistWithPost(dListCode: string): Observable<GetDlist_Response> {
    const request = new GetDlist_Request({
      dListCode: dListCode
    });

    return this.httpClient.post<GetDlist_Response>(`${this.ortServiceUrl}/GetDlist_Request`, request).pipe(
      map((res) => res as GetDlist_Response)
    );
  }


  // getFormMetadata(formId:number,
  //                 formCode:string):Observable<GetFormMetadata_Response>{

  //   const request=new GetFormMetadata_Request({
  //     formId:formId,
  //     formCode:formCode
  //   })

  //   return this.httpClient.post<GetFormMetadata_Response>(`${this.ortServiceUrl}/GetFormMetadata_Request`,request).pipe(
  //     map((res)=>{
  //       return res as GetFormMetadata_Response;
  //     })
  //   );
  // }


  getMenuTree(modulId?: number,
              app:string = "App",
              modulList?: string,
              searchText?: string): Observable<GetMenuTree_Response> {
    const request = new GetMenuTree_Request({
      modulId: modulId,
      app: app,
      modulList: modulList,
      searchText: searchText
    });
    return this.httpClient.post<GetMenuTree_Response>(`${this.ortServiceUrl}/GetMenuTree_Request`, request).pipe(
      map((res) => {
        return res as GetMenuTree_Response;
      })
    );
  }

  setRecursiveFieldData(arr: DlistDto[], transactions?: boolean, lookupMainCode?: any): ColumnModel[] {
    if (transactions === undefined) {
      transactions = true;
    }
    arr.filter(x => {
      this.mode = x?.editMode;
      this.allowAdd = x?.allowAddingYn
      this.allowDelete = x?.allowDeletingYn
      this.allowEdit = x?.allowUpdatingYn
    })
    if (this.allowDelete && this.allowEdit) {
      this.type = 4;
    } else if (this.allowDelete) {
      this.type = 2;
    } else if (this.allowAdd) {
      this.type = 8;
    } else if (this.allowEdit) {
      this.type = 1;
    }
    const returnFieldArr: ColumnModel[] = [];
    arr.forEach((element) => {
      element?.fields?.forEach((element) => {
        if (element?.lookup) {
          this.getLookup(element.lookup, 0, lookupMainCode, 0, 0).subscribe(x => {
            const lookupObj = new LookupModel();
            lookupObj.lookupAd = element.lookup
            lookupObj.data = x.items
            this.lookUpData.push(lookupObj)
            this._lookUpData.next(x);
          })
          returnFieldArr.push({
            dataField: element.dataField,
            caption: element.caption,
            dataType: element.dataType,
            type: 11,
            visibleIndex: element.orderIndex,
            fixed: element.fixedYn,
            fixedPosition: element?.fixedPosition === 'r' ? 'right' : 'left',
            width: element.width.toString(),
            visible: element.visibleYn,
            lookup: element.lookup,
            allowHiding: element.allowHidingYn,
            allowFiltering: element.allowFilterYn,
            allowSorting: element.allowSortYn,
            allowGrouping: element.allowGroupYn,
            allowEditing: element.editYn,
            hasItem: true,
            format: element.format,
            validators: element?.validators,
            sortOrder: element.sortOrder,
            sortIndex: element.sortIndex,
            groupIndex: element.groupIndex,
            dataLength: element?.dataLength,
            viewTemplate: element?.viewTemplate,
            defaultFilter: element?.defaultFilter ? (element.dataType == 'number' ? parseInt(element?.defaultFilter) : element?.defaultFilter) : null
          });
        } else if (element.options) {
          returnFieldArr.push({
            dataField: element.dataField,
            caption: element.caption,
            dataType: element.dataType,
            type: 0,
            visibleIndex: element.orderIndex,
            fixed: element.fixedYn,
            fixedPosition: element?.fixedPosition === 'r' ? 'right' : 'left',
            width: element.width.toString(),
            visible: element.visibleYn,
            allowHiding: element.allowHidingYn,
            allowFiltering: element.allowFilterYn,
            allowSorting: element.allowSortYn,
            allowGrouping: element.allowGroupYn,
            allowEditing: element.editYn,
            hasItem: true,
            format: element.format,
            validators: element?.validators,
            options: element?.options,
            dataLength: element?.dataLength,
            sortOrder: element.sortOrder,
            sortIndex: element.sortIndex,
            groupIndex: element.groupIndex,
            defaultFilter: element?.defaultFilter ? (element.dataType == 'number' ? parseInt(element?.defaultFilter) : element?.defaultFilter) : null
          });
        } else {
          returnFieldArr.push({
            dataField: element.dataField,
            width: element.width.toString(),
            caption: element.caption,
            dataType: element.dataType,
            type: element.format === 'currency' ? 6 : 0,
            visibleIndex: element.orderIndex,
            fixed: element.fixedYn,
            fixedPosition: element?.fixedPosition === 'r' ? 'right' : 'left',
            visible: element.visibleYn,
            allowHiding: element.allowHidingYn,
            allowFiltering: element.allowFilterYn,
            allowSorting: element.allowSortYn,
            allowGrouping: element.allowGroupYn,
            allowEditing: element.editYn,
            hasItem: true,
            format: element.format,
            validators: element?.validators,
            sortOrder: element.sortOrder,
            sortIndex: element.sortIndex,
            groupIndex: element.groupIndex,
            summaryType: element.totalFormula,
            dataLength: element?.dataLength,
            viewTemplate: element?.viewTemplate,
            defaultFilter: element?.defaultFilter ? (element.dataType == 'number' ? parseInt(element?.defaultFilter) : element?.defaultFilter) : null

          });
        }
      });
    });
    if (this.mode === 'custom' && transactions) {
      returnFieldArr.push({
        dataField: 'İşlemler',
        caption: '',
        dataType: '',
        type: this.type,
        fixed: true,
        fixedPosition: "right",
        visibleIndex: 9999
      });
    }
    return returnFieldArr;
  }

  /**
   * Lookup'a gonderilecek tarih parametresi.
   *
   * date1 kimi ekranda servisten gelen string ("2019-07-17T00:00:00"), kimi
   * ekranda ise dxDateBox'tan gelen gercek Date oluyordu. Date'in varsayilan
   * toString() ciktisi ("Wed Jul 17 2019 00:00:00 GMT+0300 ...") backend'de
   * parse edilemiyor; yerel gune gore yyyy-MM-dd'ye ceviriyoruz.
   * (toISOString kullanilmiyor: GMT+3'te gece yarisi bir onceki gune kayiyor.)
   */
  private formatLookupDate(date1: Date | string): string {
    if (date1 instanceof Date) {
      const pad = (n: number) => n.toString().padStart(2, '0');
      return `${date1.getFullYear()}-${pad(date1.getMonth() + 1)}-${pad(
        date1.getDate()
      )}`;
    }
    return date1.toString();
  }

  getLookup(lookupAd: string, donemKod: number, anaKod: number, page: number, count: number,filterKod?:string,
    anaKodStr?:string, date1?:Date, aktifEh?:string): Observable<GetLookup_Response> {
    var params = new HttpParams()
    if(lookupAd?.length > 0) params = params.set('lookupAd', lookupAd)
    if(donemKod)params = params.set('Donem', donemKod.toString())
    if(anaKod)params = params.set('anaKod', anaKod.toString())
    if(page)params = params.set('page', page.toString())
    if(count)params = params.set('count', count.toString())
    if(filterKod)params = params.set('filterKod', filterKod.toString())
    if(anaKodStr) params =params.set('anaKodStr', anaKodStr)
    if(date1) params =params.set('date1', this.formatLookupDate(date1))
    if(aktifEh) params =params.set('aktifEh', aktifEh)
    return this.httpClient.get<GetLookup_Response>(`${this.ortServiceUrl}/GetLookup_Request`, { params }).pipe(
      map((res) => res as GetLookup_Response)
    );
  }

  getLookupPost(lookupAd: string,
    anaKod?: number,
    donemKod?: number,
    page?: string,
    count?: string,
    filterKod?:string,
    anaKodStr?:string,
                date1?:Date,
                aktifEh?:string
  ): Observable<any> {
    const formData = new FormData();
    formData.append('lookupAd', lookupAd);
    if (anaKod) formData.append('anaKod', anaKod.toString());
    if (donemKod) formData.append('Donem', donemKod.toString());
    if (filterKod) formData.append('filterKod', filterKod.toString());
    if (page) formData.append('page', page);
    if (count) formData.append('count', count);
    if (anaKodStr) formData.append('anaKodStr', anaKodStr);
    if (date1) formData.append('date1', this.formatLookupDate(date1));
    if (aktifEh) formData.append('aktifEh', aktifEh);

    return this.httpClient.post(
      `${environment.lookupService}api/GetLookup_Request?jsconfig=eccn%2Cedv`,
      formData
    );
  }


  /*START Mal Beyan Akraba Kodu için özel yazıldı */
  clearLookupData(): void {
    this.lookUpData = [];
    this._lookUpData.next(null);
  }

  setRecursiveFieldDataLookupCode(arr: DlistDto[], transactions: boolean = true, lookupMainCode?: any): ColumnModel[] {
    this.clearLookupData();
    const returnFieldArr: ColumnModel[] = [];
    arr.forEach((element) => {
      element?.fields?.forEach((field) => {
        const columnModel: ColumnModel = {
          dataField: field.dataField,
          caption: field.caption,
          dataType: field.dataType,
          type: 0,
          visibleIndex: field.orderIndex,
          fixed: field.fixedYn,
          width: field.width.toString(),
          visible: field.visibleYn,
          allowHiding: field.allowHidingYn,
          allowFiltering: field.allowFilterYn,
          allowSorting: field.allowSortYn,
          allowGrouping: field.allowGroupYn,
          allowEditing: field.editYn,
          hasItem: true,
          format: field.format,
          validators: field?.validators,
          sortOrder: field.sortOrder,
          sortIndex: field.sortIndex,
          groupIndex: field.groupIndex,
        };

        if (field?.lookup) {
          columnModel.type = 11;
          columnModel.lookup = field.lookup;
          this.getLookupCode(field.lookup, 0, lookupMainCode, 0, 0).subscribe(x => {
            const index = this.lookUpData.findIndex(l => l.lookupAd === field.lookup);
            if (index !== -1) {
              this.lookUpData.splice(index, 1);
            }
            const lookupObj = new LookupModel();
            lookupObj.lookupAd = field.lookup;
            lookupObj.data = x.items;
            this.lookUpData.push(lookupObj);
            this._lookUpData.next(lookupMainCode);
          });
        } else if (field.options) {
          columnModel.options = field.options;
        } else if (field.format === 'currency') {
          columnModel.type = 6;
        }

        returnFieldArr.push(columnModel);
      });
    });

    if (this.mode === 'custom' && transactions) {
      returnFieldArr.push({
        dataField: 'İşlemler',
        caption: '',
        dataType: '',
        type: this.type,
        fixed: true,
        fixedPosition: "right"
      });
    }

    return returnFieldArr;
  }

  getLookupCode(lookupAd: string,
                donemKod: number,
                anaKod: number,
                page: number,
                count: number): Observable<GetLookup_Response> {

    const request = new GetLookup_Request({
      lookupAd: lookupAd,
      donemKod: donemKod,
      anaKod: anaKod,
      page: page,
      count: count
    });

    return this.httpClient.post<GetLookup_Response>(`${this.ortServiceUrl}/GetLookup_Request`, request).pipe(
      map((res) => {
        return res as GetLookup_Response;
      })
    );
  }

  /*END Mal Beyan Akraba Kodu için özel yazıldı */

  setRecursiveFieldTotalData(arr: DlistDto[]): ColumnModel[] {
    const returnFieldTotalArr: ColumnModel[] = [];
    arr.forEach((element) => {
      element?.fields?.forEach((element) => {
        if (element.totalFormula) {
          returnFieldTotalArr.push({
            column: element.dataField,
            summaryType: element.totalFormula,
          });
        }
      });
    });
    return returnFieldTotalArr;
  }


  getDashboard(dashboardGroupName: string, dashboardKod?: number): Observable<DABDashboard_Response> {
    const request = new DABDashboard_Request({
      dashboardGroupName: dashboardGroupName,
      // Analiz Merkezi: tek dashboard (yoksa alan gönderilmez, menüdeki grup isteği aynen kalır)
      ...(dashboardKod ? { dashboardKod } : {})
    });

    return this.httpClient.post<DABDashboard_Response>(`${this.ortServiceUrl}/DABDashboard_Request`, request).pipe(
      map((res) => {
        return res as DABDashboard_Response;
      })
    );
  }


  getDListAction(requestEntity: DListAction_Request): Observable<BaseResponse> {
    return this.httpClient.post<BaseResponse>(`${this.ortServiceUrl}/DListAction_Request`, requestEntity).pipe(
      map((res) => {
        return res as BaseResponse;
      })
    );
  }

  getLastXAction(request: any): Observable<BaseResponse> {
    return this.httpClient.post<BaseResponse>(`${this.ortServiceUrl}/GetLastXAction_Request`, request).pipe(
      map((res) => {
        return res as BaseResponse;
      })
    );
  }


  getFormAction(request: FormAction_Request): Observable<BaseResponse> {
    return this.httpClient.post<BaseResponse>(`${this.ortServiceUrl}/FormAction_Request`, request).pipe(
      map((res) => {
        return res as BaseResponse;
      })
    );
  }


  getReportAction(request: ReportAction_Request): Observable<BaseResponse> {
    return this.httpClient.post<BaseResponse>(`${this.ortServiceUrl}/ReportAction_Request`, request).pipe(
      map((res) => {
        return res as BaseResponse;
      })
    );
  }


  getReportActionWithPdf(request: ReportAction_Request): Observable<ReportAction_Response> {
    return this.httpClient.post<ReportAction_Response>(`${this.ortServiceUrl}/ReportAction_Request`, request).pipe(
      map((res) => {
        return res as ReportAction_Response;
      })
    );
  }


  getFormMetadata(request: GetFormMetadata_Request): Observable<GetFormMetadata_Response> {
    const updatedRequest = {
      formAd: request.formAd?.slice(request.formAd?.lastIndexOf("/") + 1),
      altFormAd: request.altFormAd,
      kod: request.kod,
      logYn: request.logYn
    };
    return this.httpClient.post<GetFormMetadata_Response>(`${this.ortServiceUrl}/GetFormMetadata_Request`, updatedRequest).pipe(
      map((res) => {
        return res as GetFormMetadata_Response;
      }),
      catchError((error) => {
        this.utilsService.showError(error);
        throw error;
      })
    );
  }

  getNewFormData(entity: string, donem?: any, anaKod?: any, status?: any, gelenGiden?: any, modulKod?: any, emlakBeyanTuru?: any): Observable<any> {
    const request = {
      entity: entity,
      donem: donem || null,
      anaKod: anaKod || null,
      status: status,
      gelenGiden: gelenGiden || null,
      modulKod: modulKod || null,
      emlakBeyanTuru: emlakBeyanTuru || null
    };
    return this.httpClient.get<any>(`${environment.dataService + request.entity}/new?Donem=${request.donem}&AKod=${request.anaKod}&GelenGiden=${request.gelenGiden}&ModulKod=${request.modulKod}&EmlakBeyanTuru=${request.emlakBeyanTuru}`).pipe(
      map((res) => {
        // Response'tan '@odata.context' alanını kaldır
        const {['@odata.context']: _, ...cleanedRes} = res;
        Object.keys(cleanedRes).forEach(key => {
          const value = cleanedRes[key];

          // Eğer değer obje veya array ise çıkart
          if (typeof value === 'object' && value !== null) {
            delete cleanedRes[key];  // Objeyi veya array'i çıkart
          }
        });
        return cleanedRes;
      })
    ).pipe(
      catchError((err) => {
        // QA-3k/8 Clara: showError'a ham hata nesnesi verilmeli; (status, name) verilince
        // extractServiceMessages hatayi tanimiyor ve backend mesaji yerine
        // "Islem gerceklestirilemedi!" genel mesaji cikiyordu. getFormMetadata zaten ham hatayi veriyor.
        // QA-3k/8 eski hali: this.utilsService.showError(err?.status,err?.name);
        this.utilsService.showError(err);
        throw err;
      })
    );
  }

  getParametreDeger(parametreAdi: string): Observable<GetParametreDeger_Response> {
    const params = new HttpParams().
    set('parametreAdi', parametreAdi);

    return this.httpClient.get<GetParametreDeger_Response>(`${this.ortServiceUrl}/GetParametreDeger_Request`, { params }).pipe(
      map((res) => res as GetParametreDeger_Response)
    );
  }



  filterActionsWithFormYer(actions: FormActionDto[], formYer: string): ButtonWithIconObject[] {
    if (!actions) return [];

    return actions
      .filter(action => action?.formYer === formYer)
      .map(action => ({
        value: action.islemAd,
        name: action.islemBaslik,
        icon: action.icon,
        disable: !action.aktifYn,
        disabled: !action.aktifYn,
        orderIndex: action.orderIndex
      }))
      .sort((a, b) => {
        const aHasOrder = typeof a.orderIndex === 'number';
        const bHasOrder = typeof b.orderIndex === 'number';

        if (aHasOrder && bHasOrder) {
          return a.orderIndex - b.orderIndex;
        } else if (aHasOrder) {
          return -1;
        } else if (bHasOrder) {
          return 1;
        } else {
          return (a.name || '').localeCompare(b.name || '');
        }
      });
  }


  filterCustomActionsWithFormYer(actions: FormActionDto[], formYer: string, textVisible?: boolean): DynamicButton[] {
    if (!actions) return [];

    return actions
      .filter(action => action?.formYer === formYer)
      .map(action => ({
        name: action?.islemAd,
        text: action.bTextVisibleYn ? action?.islemBaslik : '',
        icon: action?.icon || 'eyeopen',
        hint: action?.islemHint,
        type: action?.bType,
        stylingMode: action?.bStylingMode,
        style: action?.bStyle,
        width: action?.bWitdh,
        donemKontrolYn: action?.donemKontrolYn,
        disabled: !action.aktifYn,
        orderIndex: action.orderIndex
      }))
      .sort((a, b) => {
        const aHasOrder = typeof a.orderIndex === 'number';
        const bHasOrder = typeof b.orderIndex === 'number';

        if (aHasOrder && bHasOrder) {
          return a.orderIndex - b.orderIndex;
        } else if (aHasOrder) {
          return -1;
        } else if (bHasOrder) {
          return 1;
        } else {
          return (a.hint || '').localeCompare(b.hint || '');
        }
      });
  }


  filterActivePanelItems(
    actions: FormActionDto[],
    formYer: string,
    tabValues: { [key: string]: number }
  ): any[] {
    if (!actions) return [];

    return actions
      .filter(action => action?.formYer === formYer && action.aktifYn) // Sadece aktif olanları al
      .map(action => ({
        text: action?.islemBaslik || 'Bilinmeyen',
        value: tabValues[action?.islemAd] ?? -1, // Eğer tanımlı değilse -1 ata
        key: tabValues[action?.islemAd] ?? -1
      }))
      .filter(item => item.value !== -1) // Tanımlı olmayanları filtrele
      .sort((a, b) => a.key - b.key); // key'e göre küçükten büyüğe sırala
  }





  getFormName(page: any): string {
    return page?.slice(page?.lastIndexOf("/") + 1)
  }

  // DKM-5225 Clara: isteğe bağlı `query` ('IkYetki=E' gibi) tekil okuma adresine ?query olarak eklenir; verilmezse adres aynı.
  getEditFormDataWithKod(kod: number, entity: string, includedEntities?: string[], query?: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // DKM-5225 Clara: eski hâli
      // this.httpClient.get(`${environment.dataService + entity}/${kod}`).pipe(take(1)).subscribe({
      this.httpClient.get(`${environment.dataService + entity}/${kod}${query ? '?' + query : ''}`).pipe(take(1)).subscribe({
        next: (res) => {
          resolve([res]); // Veriyi promise ile resolve ediyoruz
        },
        error: (err) => {
          // QA-3k/9 Clara: showError'a ham hata nesnesi verilmeli. (name, status) verilince
          // toast govdesine hata SINIF ADI ("HttpErrorResponse"), basligina durum kodu basiliyordu;
          // backend'in ServiceStack mesaji tamamen kayboluyordu. (getNewFormData ile de ters sirada, tutarsizdi.)
          // QA-3k/9 eski hali: this.utilsService.showError(err?.name,err?.status)
          this.utilsService.showError(err)
         reject(err); // Hata durumunda promise'i reject ediyoruz
        }
      });
    });
  }

  async getViewDataWithFilter(entity: string, keyField:string='Kod', filterArr?: any[]): Promise<any[]> {
    const dataSource = this.dataCoreService.getOData(entity, null,null, keyField,);
    dataSource.filter(filterArr);

    try {
      await dataSource.load();
      const items = dataSource.items();
      return items;
    } catch (error) {
      console.error(`Hata [${entity}] veri çekilirken:`, error);
      throw error;
    }
  }



  getControl(controlName: string): Observable<any> {
    const params = new HttpParams()
    .set('controlCode', controlName);
    return this.httpClient.get(
      `${this.ortServiceUrl}/GetControlMetadata_Request`,
      {params}
    );

 /*    const request = new GetControlMetadata_Request({
      controlCode: controlName
    });
    return this.httpClient.post<GetControlMetadata_Request>(`${this.ortServiceUrl}/GetControlMetadata_Request`, request).pipe(
      map((res) => res as any)
    ); */

  }


  updateInlineFormYetkiWithDonem(formMetaData: any, donem: any) {
    if (donem?.AktifEh === 'H') {
      return {
        ...formMetaData?.formYetki, // Diğer yetkileri koru
        insertYn: false,
        updateYn: false,
        deleteYn: false,
      };
    } else {
      return formMetaData?.formYetki;
    }
  }

  updateCustomFormYetkiWithDonem(formMetaData: any, donem: any) {
    if (donem?.AktifEh === 'H') {
      return {
        ...formMetaData?.formYetki, // Diğer yetkileri koru
        insertYn: false,
        updateYn: true,
        deleteYn: false,
      };
    } else {
      return formMetaData?.formYetki;
    }
  }

  updateCustomFormYetkiWithAmbar(formMetaData: any, ambar: any) {
    if (ambar?.ambarAktifEh === 'H') {
      return {
        ...formMetaData?.formYetki, // Diğer yetkileri koru
        insertYn: false,
        updateYn: true,
        deleteYn: false,
      };
    } else {
      return formMetaData?.formYetki;
    }
  }


  getLoginUser(personelKod?: number) {
    const request = new GetPersonelBilgi_Request({
      personelKod: personelKod || 0
    });
    return this.httpClient.post<GetPersonelBilgi_Response>(`${environment.ortakService}api/GetPersonelBilgi_Request`, request).pipe(
      map((res) => {
        return res as GetPersonelBilgi_Response;
      }));

  }

  getKullaniciBilgi(device:string): Observable<GetKullaniciBilgi_Response> {
    if (!this.kullaniciBilgi$) {
      const request = new GetKullaniciBilgi_Request({device:device});
      this.kullaniciBilgi$ = this.httpClient
        .post<GetKullaniciBilgi_Response>(
          `${environment.ortakService}api/GetKullaniciBilgi_Request`,
          request
        )
        .pipe(
          map((res) => res as GetKullaniciBilgi_Response),
          // QA-3k/12 (2026-09-21): "hata kalici onbellege giriyor" bulgusu YANLIS CIKTI, kod
          // degistirilmedi. rxjs 7.8.1'de shareReplay varsayilani resetOnError:true oldugu icin
          // kaynak hata verince paylasim sifirlaniyor; HttpClient observable'i cold oldugundan
          // bir sonraki abonelik YENI istek atiyor. Tarayicida dogrulandi: gecici 503 -> /error,
          // ardindan sayfa YENILENMEDEN ana sayfaya donulebiliyor (2 istek).
          shareReplay(1) // Sonucu cache'ler ve paylaşır
        );
    }
    return this.kullaniciBilgi$;
  }

  getKullaniciAd(kayitKullaniciKod: number, degisKullaniciKod: number): Observable<GetKullaniciAd_Response> {
    const request = new GetKullaniciAd_Request({ kayitKullaniciKod, degisKullaniciKod });
    return this.httpClient.post<GetKullaniciAd_Response>(
      `${environment.ortakService}api/GetKullaniciAd_Request`,
      request
    );
  }


  normalizeForm(form: any): any {
    return JSON.parse(
      JSON.stringify(form, (key, value) => {
        if (value === null || value === '' || value === 0) {
          return null;
        }
        return value;
      })
    );
  }

  findDifferences(obj1: any, obj2: any, path: string = ''): string[] {
    const differences: string[] = [];

    for (const key in obj1) {
      const currentPath = path ? `${path}.${key}` : key;

      if (!(key in obj2)) {
        differences.push(`${currentPath}: key missing in second object`);
      } else if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
        if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
          differences.push(...this.findDifferences(obj1[key], obj2[key], currentPath));
        } else {
          differences.push(`${currentPath}: ${obj1[key]} !== ${obj2[key]}`);
        }
      }
    }

    for (const key in obj2) {
      if (!(key in obj1)) {
        differences.push(`${path ? `${path}.` : ''}${key}: key missing in first object`);
      }
    }

    return differences;
  }



  getKaynakArsiv(kaynakKod:number,kaynak:string) {
    const request = new GAS_Get_ArsivKod_Request({
      kaynakKod:kaynakKod,
      kaynak: kaynak
    });
    return this.httpClient.post<GAS_Get_ArsivKod_Response>(`${environment.bysService}api/GAS_Get_ArsivKod_Request`, request).pipe(
      map((res) => {
        return res as GAS_Get_ArsivKod_Response;
      }))
  }

  async SetDlist_Request(request?: SetDlist_Request): Promise<ApiResult<GetDlist_Response>> {
    return await this.client.api(new SetDlist_Request({
      dListCode: request?.dListCode,
      resetYn: request?.resetYn,
      rol: request?.rol,
      dxColumns: request?.dxColumns,
    }));
  }
  async GetLastXAction_Request(request?:GetLastXAction_Request ):Promise<any>
  {
    return await this.client.api(new GetLastXAction_Request({
      formAd:request?.formAd,
    }));
  }

  async IkaGUI_PersonelIzin_Request(request?:IkaGUI_PersonelIzin_Request ):Promise<any>
  {
    return await this.clientGen.api(new IkaGUI_PersonelIzin_Request({
      personelKod:request?.personelKod,
      kontrolTarih:request?.kontrolTarih,
    }));
  }
}
